import React from "react";
import TableOfContents from "../../TableOfContents/TableOfContents.tsx";
import TocMobile from "../../ToCTelephone/TocTelephone.tsx";
// import the corresponding css file
import "./SpaCResults.css";
// import the separated file related to the component
import TextSpaCResults from "./TextSpaCResults.jsx";

const SpaCResults = () => {
  // headingData is used in the TableOfContents
  // every title (h2, h3, etc) used in the separated file of the component should be in the table
  const headingsData = [
    {
      // the level 2 is the most important level you can have (the basic one)
      level: 2,
      // the text will be displayed in the table of contents
      text: "SpaC results",
      // the id should be the same as the one used in the separated file of the component else the name of the title would not be displayed as wanted
      // do not use space for the id
      id: "SpaC_results_s",
    },
    {
      level: 3,
      text: "Expression of SpaC: Expression Under Varied Conditions",
      id: "Expression_SpaC_s",
    },
    {
      // level 3 has a specific style so the title in the TOC will be display on the right of a level 2 title
      level: 3,
      text: "Surface Display:Immunofluorescence",
      id: "Surface_Display_SpaC_s",
    },
    {
      level: 2,
      text: "D1D2 & D2 results:",
      id: "D1D2_D2_results_s",
    },
    {
      level: 3,
      text: "Cloning D2",
      id: "Cloning_D2_s",
    },

    {
      level: 3,
      text: "Cloning D1D2",
      id: "Cloning_D1D2_s",
    },
    {
      level: 3,
      text: "Sequencing of D2 and D1D2",
      id: "sequencing_D2-D1D2_s",
    },
    {
      level: 3,
      text: "Expression Under Varied Conditions",
      id: "Expression_D1D2_s",
    },
    {
      level: 3,
      text: "Immunofluorescence assay",
      id: "Surface_Expression_D1D2_s",
    },
    {
      level: 3,
      text: "Assessment of Half-Life",
      id: "Half_Life_Assessment_D1D2_s",
    },
    {
      level: 2,
      text: "Mucus-Binding:",
      id: "Mucus_Binding_D1D2_s",
    },
    {
      level: 3,
      text: "First Mucus-Binding Experiment",
      id: "Mucus_Binding1_D1D2_s",
    },
    {
      level: 3,
      text: "Second Mucus-Binding Experiment",
      id: "Mucus_Binding2_D1D2_s",
    },
    {
      level: 3,
      text: "Reproduce phenotype of D2 and D1D2",
      id: "Reproduce_pheonotype_s",
    },
    {
      level: 3,
      text: "Optimizing the Dilution for the testing strains",
      id: "Find_optimal_concentration_s",
    },
    {
      level: 3,
      text: "Optimizing the Dilution for the negative control (SpaC)",
      id: "Find_Concentration_SpaC_s",
    },
    {
      level: 3,
      text: "Third Mucus-Binding Experiment",
      id: "Third_Experiment_D1D2_s",
    },
    {
      level: 2,
      text: "What went wrong",
      id: "What_did_go_wrong_SpaC_s",
    },
    {
      level: 3,
      text: "Surface Expression SpaC",
      id: "Surface_Expression_SpaC_s",
    },
    {
      level: 3,
      text: "Sonication",
      id: "Sonication_SpaC_s",
    },
    {
      level: 2,
      text: "References",
      id: "References_s",
    },
  ];

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div>
        {/* divide the section in columns */}
        <div className="grid grid-cols-12 gap-4" style={{ marginLeft: "50px" }}>
          {/* section on the left (=Table of content) */}
          <div className="hidden md:block col-span-4 ml-6 order-2 md:order-1">
            {/* it will stay visible on the viewport */}
            <div className="sticky top-4 scrollable">
              {/* call the Table of contents with headingData modified above */}
              <TableOfContents headings={headingsData} />
            </div>
          </div>
          {/* main content which is a separated file you call and it is displayed on the right of the section above */}
          <main className="prose col-span-12 md:col-span-8 order-1 md:order-2">
            <TextSpaCResults />
          </main>
          {/* display the table of content when the viewport is too small */}
          <div className="md:hidden col-span-12 order-3">
            <TocMobile headings={headingsData} />
          </div>
        </div>
      </div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SpaCResults;
